function helpHandleRequest( requestData ) {
    $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: requestData,
        processData: false,
        contentType: false,
        beforeSend: function (){
            $('.allYachtContainer__loader').addClass('is_show');
        }
    }).done(function(response){
        let resp = JSON.parse(response);
        $('.allYachtsContainer').html(resp.yachts);
        $('.allYachtsPagination').html(resp.pagination);
        console.log( resp.debug );
        setTimeout(function(){
            $('.allYachtContainer__loader').removeClass('is_show');
        }, 300);
    })
}

export default function handleFilterChange(filterElemSelector) {
    let filters = {};
    const filterElems = $(filterElemSelector);
    const pageID = filterElems.parents('aside.filter').data('page_id');
    if( filterElems.length > 1 ) {
        filterElems.each(function(index, value) {
            let filterTermId = $(value).data('filter_id');
            let filterParentTermId = $(value).parents('.filter__row').data('group_id');
            filters[filterParentTermId] = [];

            if( $(value).prop('checked') || $(this).prop('checked') || this.checked ) {
                filters[filterParentTermId].push(filterTermId);
            }
            $(value).change(function(){
                if( $(this).prop('checked') ) {
                        filters[filterParentTermId].push(filterTermId);
                } else {
                    if( filters[filterParentTermId].includes( filterTermId ) ) {
                        filters[filterParentTermId].splice(filters[filterParentTermId].indexOf(filterTermId), 1);
                    }
                }

                const yachtFilterData = new FormData();
                yachtFilterData.append('action', 'yacht_filters');
                yachtFilterData.append('required_page', 1);
                yachtFilterData.append('page_id', pageID );
                yachtFilterData.append('filters', JSON.stringify(filters) );

                helpHandleRequest( yachtFilterData );
            });
        })
    }
}

export function yachtPagination(filterElemSelector) {
    const requestData = new FormData();

    requestData .append('action', 'yacht_filters');
    const allFilter = $(filterElemSelector);
    const pageID = allFilter.parents('aside.filter').data('page_id');
    requestData .append('page_id', pageID );


    $('body').on('click', '.pagination__next_page', function(){
        let filtersTest = {};
        const allFilterElems = $(`${filterElemSelector}`+':checked');
        let requiredPaginationPage = $(this).data('page_next');
        let allFilterGroups = $('.filter__row');
        if ( allFilterGroups.length > 0 ) {
            allFilterGroups.each( function(index, value) {
                filtersTest[$(value).data('group_id')] = [];
            } );
        }

        if ( allFilterElems.length > 0 ) {
            allFilterElems.each(function(index, value) {
                let filterTermId = $(value).data('filter_id');
                let filterParentTermId = $(value).parents('.filter__row').data('group_id');
                if( $(value).prop('checked') || $(this).prop('checked') || this.checked ) {
                    filtersTest[filterParentTermId].push(filterTermId);
                }
            });
        }
        requestData.append('filters', JSON.stringify(filtersTest) );
        requestData.append('required_page', parseInt(requiredPaginationPage));
        helpHandleRequest( requestData );
    });


    $('body').on('click', '.pagination__prev_page', function(){
        let filtersTest = {};
        const allFilterElems = $(`${filterElemSelector}`+':checked');
        let requiredPaginationPage = $(this).data('page_prev');
        let allFilterGroups = $('.filter__row');
        if ( allFilterGroups.length > 0 ) {
            allFilterGroups.each( function(index, value) {
                filtersTest[$(value).data('group_id')] = [];
            } );
        }

        if ( allFilterElems.length > 0 ) {
            allFilterElems.each(function(index, value) {
                let filterTermId = $(value).data('filter_id');
                let filterParentTermId = $(value).parents('.filter__row').data('group_id');
                if( $(value).prop('checked') || $(this).prop('checked') || this.checked ) {
                    filtersTest[filterParentTermId].push(filterTermId);
                }
            });
        }
        requestData.append('filters', JSON.stringify(filtersTest) );
        requestData.append('required_page', parseInt(requiredPaginationPage));
        helpHandleRequest( requestData );
    });



    $('body').on('click', '.pagination__page', function(){
        let filtersTest = {};
        const allFilterElems = $(`${filterElemSelector}`+':checked');
        let requiredPaginationPage = $(this).data('page');
        let allFilterGroups = $('.filter__row');
        if ( allFilterGroups.length > 0 ) {
            allFilterGroups.each( function(index, value) {
                filtersTest[$(value).data('group_id')] = [];
            } );
        }

        if ( allFilterElems.length > 0 ) {
            allFilterElems.each(function(index, value) {
                let filterTermId = $(value).data('filter_id');
                let filterParentTermId = $(value).parents('.filter__row').data('group_id');
                if( $(value).prop('checked') || $(this).prop('checked') || this.checked ) {
                    filtersTest[filterParentTermId].push(filterTermId);
                }
            });
        }
        requestData.append('filters', JSON.stringify(filtersTest) );
        requestData.append('required_page', parseInt(requiredPaginationPage));
        helpHandleRequest( requestData );
    });

}


// WEBPACK FOOTER //
// app/scripts/components/yachtFilters.js